import gql from "graphql-tag";

export const TRAINING_REQUESTS = gql`
  query filterWithPaginateTrainingRequests($criteria: TrainingRequestFilterCriteria!, $pagination: Pagination!) {
    filterWithPaginateTrainingRequests(criteria: $criteria, pagination: $pagination) {
      pageInfo {
        totalElements
      }
      content {
        id
        detail
        training {
          id
          name
          color
        }
        abolisher {
          id
          firstName
          lastName
          profile {
            imageUrl
          }
        }
        abolishDateTime
        abolishReason
        trainingPlanned
        requester {
          id
          firstName
          lastName
          profile {
            imageUrl
          }
        }
        trainingRequestStatus
        requestDateTime
        trainingRequestProcesses {
          id
          approver {
            firstName
            lastName
            profile {
              imageUrl
            }
            employment {
              branch {
                name
              }
            }
          }
          approved
          note
          eventDateTime
          nextApprover
        }
      }
    }
  }
`;
